import { login, reload, restore } from '../common/api';

const user = {
    name: 'user',
    state: { 
        password: false,
        socket: null,
        meta: {
            contact: {},
            loan: {},
            gift: {},
            event: {},
            global: {},
            nav: []
        },
        crm: {},
        lists: {
            users: [],
            contacts: []
        },
        viewing: []
    },
    reducers: {
        l: ( state, payload ) => {
            const v = [];
            if ( payload.additionalAccounts && payload.additionalAccounts.length ) {
                payload.additionalAccounts.forEach( f => {
                    if ( f.default ) {
                        v.push( f.aid );
                    }
                })
            }
            if ( !v.length ) {
                v.push( payload.aid );
            }

            return {
                ...state,
                ...payload,
                viewing: [ ...v ]
            }
        },
        lo: () => {
            return {
                password: false,
                socket: null,
                meta: {
                    contact: {},
                    loan: {},
                    gift: {},
                    event: {},
                    global: {},
                    nav: []
                },
                crm: {},
                lists: {
                    users: [],
                    contacts: []
                },
                viewing: []
            }
        },
        sa: ( state, payload ) => {
            return { 
                ...state,
                aid: payload
            }
        },
        sv: ( state, payload ) => {
            return {
                ...state,
                viewing: [ ...payload ]
            }
        },
        setSocket: ( state, payload ) => {
            return {
                ...state,
                socket: payload
            }
        },
        sdgw: ( state, payload ) => {
            let grid = { ...state.datagrids };
            if ( !grid[payload.grid] ) {
                if ( payload.fn && payload.fn.length ) {
                    grid[payload.grid] = {
                        filters: {
                            [payload.fn]: {
                                colSize: payload.values
                            }
                        }
                    }
                } else {
                    grid[payload.grid] = {
                        colSize: payload.values
                    }
                }
            } else {
                if ( payload.fn && payload.fn.length ) {
                    if ( grid[payload.grid].filters ) {
                        if ( grid[payload.grid].filters[payload.fn] ) {
                            grid[payload.grid].filters[payload.fn].colSize = payload.values;
                        } else {
                            grid[payload.grid].filters[payload.fn] = {
                                colSize: payload.values
                            }
                        }
                    } else {
                        grid[payload.grid].filters = {
                            [payload.fn]: {
                                colSize: payload.values
                            }
                        }
                    }
                } else {
                    grid[payload.grid].colSize = payload.values;
                }
            }
            return {
                ...state,
                datagrids: {
                    ...grid
                }
            }
        },
        sdgo: ( state, payload ) => {
            let grid = { ...state.datagrids };
            if ( !grid[payload.grid] ) {
                if ( payload.fn && payload.fn.length ) {
                    grid[payload.grid] = {
                        filters: {
                            [payload.fn]: {
                                colOrder: payload.values
                            }
                        }
                    }
                } else {
                    grid[payload.grid] = {
                        colOrder: payload.values
                    }
                }
            } else {
                if ( payload.fn && payload.fn.length ) {
                    if ( grid[payload.grid].filters ) {
                        if ( grid[payload.grid].filters[payload.fn] ) {
                            grid[payload.grid].filters[payload.fn].colOrder = payload.values;
                        } else {
                            grid[payload.grid].filters[payload.fn] = {
                                colOrder: payload.values
                            }
                        }
                    } else {
                        grid[payload.grid].filters = {
                            [payload.fn]: {
                                colOrder: payload.values
                            }
                        }
                    }
                } else {
                    grid[payload.grid].colOrder = payload.values;
                }
            }
            return {
                ...state,
                datagrids: {
                    ...grid
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async setAccount( { aid, uid } ) {
            dispatch.user.sa( aid );
            const user = await reload( uid );
            if ( user.password ) {
                dispatch.user.l( user );
            }
            return ( user.password );
        },
        async login( { email, pwd } ) {
            const user = await login( email, pwd );
            if ( user.password ) {
                dispatch.user.l( user );
            }
            return ( user.password );
        },
        logout() {
            dispatch.user.lo();
        },
        async restoreSession( { uid, sid } ) {
            const user = await restore( uid, sid );
            if ( user.password ) {
                dispatch.user.l( user );
            }
            return ( user.password );
        },
        storeSocket( socket ) {
            console.log( 'storing socket: ', socket );
            dispatch.user.setSocket( socket );
        },
        setViewing( aids ) {
            console.log( 'setting: ', aids );
            dispatch.user.sv( aids );
        },
        setDatagridWidth( { grid, values, fn } ) {
            console.log( 'setting widths: ' + grid, values, fn );
            dispatch.user.sdgw( { grid: grid, values: values, fn: fn } );
        },
        setDatagridOrder( { grid, values, fn } ) {
            console.log( 'setting order: ' + grid, values, fn );
            dispatch.user.sdgo( { grid: grid, values: values, fn: fn } );
        }
    } )
}

export default user;